import { render, staticRenderFns } from "./dispatchModal.vue?vue&type=template&id=00c845e4&"
import script from "./dispatchModal.vue?vue&type=script&lang=js&"
export * from "./dispatchModal.vue?vue&type=script&lang=js&"
import style0 from "./dispatchModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports